function select(selector, element) {
	const node = element.querySelector(selector);
	if (!node) {
		throw new Error(`Could not find element with selector ${selector}`);
	}
	return node;
}

function querySelect(
	selectors,
	element = document
) {
	if (typeof selectors === 'string') {
		return select(selectors, element);
	} else if (typeof selectors === 'object') {
		return Object.entries(selectors).reduce(function (prev, [key, selector]) {
			return {
				...prev,
				[key]: select(selector, element)
			}
		}, {});
	}
}

module.exports = querySelect;
